<div class="a-progress-container">
    <div class="a-progress-wrapper">
        <div class="a-progress-inner" [style.width.%]="value"></div>
    </div>
    <div class="a-progress-number">{{value}}%</div>
</div>